"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = exports.OrderLineStatus = exports.OrderLineAction = void 0;
var OrderLineAction;
(function (OrderLineAction) {
    OrderLineAction["ALTERNATE_TEE_TIME_ACCEPTED"] = "ALTERNATE_TEE_TIME_ACCEPTED";
    OrderLineAction["ALTERNATE_TEE_TIME_REJECTED"] = "ALTERNATE_TEE_TIME_REJECTED";
    OrderLineAction["UPDATE_TRANSFER_LINE_CONFIG"] = "UPDATE_TRANSFER_LINE_CONFIG";
})(OrderLineAction = exports.OrderLineAction || (exports.OrderLineAction = {}));
var OrderLineStatus;
(function (OrderLineStatus) {
    OrderLineStatus["PENDING"] = "PENDING";
    OrderLineStatus["CHANGE_REQUESTED"] = "CHANGE_REQUESTED";
    OrderLineStatus["MISSING_SUPPLIER_EMAIL"] = "MISSING_SUPPLIER_EMAIL";
    OrderLineStatus["WAITING_FOR_SUPPLIER"] = "WAITING_FOR_SUPPLIER";
    OrderLineStatus["WAITING_FOR_CLIENT_TRANSFER_INFO"] = "WAITING_FOR_CLIENT_TRANSFER_INFO";
    OrderLineStatus["WAITING_FOR_SUPPLIER_OVERDUE"] = "WAITING_FOR_SUPPLIER_OVERDUE";
    OrderLineStatus["URGENT_ACTION_REQUIRED"] = "URGENT_ACTION_REQUIRED";
    OrderLineStatus["WAITING_TO_SEND"] = "WAITING_TO_SEND";
    OrderLineStatus["AWAITING_DEPOSIT"] = "AWAITING_DEPOSIT";
    OrderLineStatus["CONFIRMED"] = "CONFIRMED";
    OrderLineStatus["CONFIRMED_PAID"] = "CONFIRMED_PAID";
    OrderLineStatus["ALTERNATIVE_OFFERED"] = "ALTERNATIVE_OFFERED";
    OrderLineStatus["ALTERNATIVE_OFFERED_OVERDUE"] = "ALTERNATIVE_OFFERED_OVERDUE";
    OrderLineStatus["CANCELLED"] = "CANCELLED";
    OrderLineStatus["CANCELLED_UNAVAILABLE"] = "CANCELLED_UNAVAILABLE";
    OrderLineStatus["CANCELLED_REJECTED"] = "CANCELLED_REJECTED";
})(OrderLineStatus = exports.OrderLineStatus || (exports.OrderLineStatus = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["QUOTE"] = "QUOTE";
    OrderStatus["QUOTE_EXPIRED"] = "QUOTE_EXPIRED";
    OrderStatus["QUOTE_CANCELLED"] = "QUOTE_CANCELLED";
    OrderStatus["NEW_BOOKNG"] = "NEW_BOOKING";
    OrderStatus["WAITING_FOR_DEPOSIT"] = "WAITING_FOR_DEPOSIT";
    OrderStatus["CONFIRMING_GOLF"] = "CONFIRMING_GOLF";
    OrderStatus["CONFIRMING_TRANSFERS"] = "CONFIRMING_TRANSFERS";
    OrderStatus["CONFIRMING_HOTELS"] = "CONFIRMING_HOTELS";
    OrderStatus["CONFIRMING_CUSTOM"] = "CONFIRMING_CUSTOM";
    OrderStatus["CONFIRMING_ALL"] = "CONFIRMING_ALL";
    OrderStatus["WAITING_FOR_BALANCE"] = "WAITING_FOR_BALANCE";
    OrderStatus["WAITING_FOR_PAYMENT"] = "WAITING_FOR_PAYMENT";
    OrderStatus["PAYMENT_OVERDUE"] = "PAYMENT_OVERDUE";
    OrderStatus["CONFIRMED"] = "CONFIRMED";
    OrderStatus["COMPLETE"] = "COMPLETE";
    OrderStatus["CANCELLED"] = "CANCELLED";
    OrderStatus["CANCELLED_UNPAID"] = "CANCELLED_UNPAID";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
